"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcProductPrices = class UcProductPrices extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    sortItems(...args) {
        return _.orderBy(args[0], ['valid_from', 'price'], ['desc', 'desc']);
    }
    product;
    onProduct(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("product");
    }
    items;
    async $$load_items() {
        return this.$fn.fetch('list_product_price', { parameters: { 'product_id': this.product.id } });
    }
    currencies;
    ux;
    dataMembers = ['items', 'currencies', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                items: null,
                currencies: ["HUF",
                    "EUR",
                    "USD",
                ],
                ux: {
                    initialLoadSpinner: true,
                },
            },
        };
    }
    get purchasePrices() {
        if (this.loaded) {
            return this.sortItems(_.filter(this.items, { is_purchase_price: true }));
        }
        return null;
    }
    get sellingPrices() {
        if (this.loaded) {
            return this.sortItems(_.filter(this.items, { is_purchase_price: false }));
        }
        return null;
    }
    async evh_3343864469950044_close_8009_getWhen($event) {
        return !!$event.data.modalResult.value;
    }
    async act_3343864469950044_showModal_8008_getActionArgs($event) {
        return {
            name: "ProductPrice",
            props: {
                product: this.product,
                is_purchase_price: false,
            },
        };
    }
    async evh_3343864469950044_clickPreventStop(event, scope) {
        return await this.actions.evh_3343864469950044_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async evh_8855792642156263_close_8013_getWhen($event) {
        return !!$event.data.modalResult.ok;
    }
    async act_8855792642156263_showModal_8012_getActionArgs($event) {
        return {
            name: "ProductPrice",
            props: {
                oid: $event.scope.item.id,
                mode: "edit",
                product: this.product,
            },
        };
    }
    async evh_8855792642156263_clickPreventStop(event, scope) {
        return await this.actions.evh_8855792642156263_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async evh_302930856768608_close_8017_getWhen($event) {
        return !!$event.data.modalResult.value;
    }
    async act_302930856768608_showModal_8016_getActionArgs($event) {
        return {
            name: "ProductPrice",
            props: {
                product: this.product,
                is_purchase_price: true,
            },
        };
    }
    async evh_302930856768608_clickPreventStop(event, scope) {
        return await this.actions.evh_302930856768608_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async evh_7972369138378646_close_8021_getWhen($event) {
        return !!$event.data.modalResult.ok;
    }
    async act_7972369138378646_showModal_8020_getActionArgs($event) {
        return {
            name: "ProductPrice",
            props: {
                oid: $event.scope.item.id,
                mode: "edit",
                product: this.product,
            },
        };
    }
    async evh_7972369138378646_clickPreventStop(event, scope) {
        return await this.actions.evh_7972369138378646_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_3343864469950044_reloadComponentData_8010 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_3343864469950044_close_8009 = new core_1.actions.EventHandlerImpl({
            action: act_3343864469950044_reloadComponentData_8010,
            event: "close",
            when: this.evh_3343864469950044_close_8009_getWhen,
            displayName: "reloadComponentData",
        });
        const act_3343864469950044_showModal_8008 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_3343864469950044_showModal_8008_getActionArgs,
            events: [evh_3343864469950044_close_8009],
        });
        const evh_3343864469950044_clickPreventStop_8007 = new core_1.actions.EventHandlerImpl({
            action: act_3343864469950044_showModal_8008,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_3343864469950044_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3343864469950044_clickPreventStop_8007],
        });
        const act_8855792642156263_reloadComponentData_8014 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_8855792642156263_close_8013 = new core_1.actions.EventHandlerImpl({
            action: act_8855792642156263_reloadComponentData_8014,
            event: "close",
            when: this.evh_8855792642156263_close_8013_getWhen,
            displayName: "reloadComponentData",
        });
        const act_8855792642156263_showModal_8012 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_8855792642156263_showModal_8012_getActionArgs,
            events: [evh_8855792642156263_close_8013],
        });
        const evh_8855792642156263_clickPreventStop_8011 = new core_1.actions.EventHandlerImpl({
            action: act_8855792642156263_showModal_8012,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_8855792642156263_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8855792642156263_clickPreventStop_8011],
        });
        const act_302930856768608_reloadComponentData_8018 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_302930856768608_close_8017 = new core_1.actions.EventHandlerImpl({
            action: act_302930856768608_reloadComponentData_8018,
            event: "close",
            when: this.evh_302930856768608_close_8017_getWhen,
            displayName: "reloadComponentData",
        });
        const act_302930856768608_showModal_8016 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_302930856768608_showModal_8016_getActionArgs,
            events: [evh_302930856768608_close_8017],
        });
        const evh_302930856768608_clickPreventStop_8015 = new core_1.actions.EventHandlerImpl({
            action: act_302930856768608_showModal_8016,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_302930856768608_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_302930856768608_clickPreventStop_8015],
        });
        const act_7972369138378646_reloadComponentData_8022 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_7972369138378646_close_8021 = new core_1.actions.EventHandlerImpl({
            action: act_7972369138378646_reloadComponentData_8022,
            event: "close",
            when: this.evh_7972369138378646_close_8021_getWhen,
            displayName: "reloadComponentData",
        });
        const act_7972369138378646_showModal_8020 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_7972369138378646_showModal_8020_getActionArgs,
            events: [evh_7972369138378646_close_8021],
        });
        const evh_7972369138378646_clickPreventStop_8019 = new core_1.actions.EventHandlerImpl({
            action: act_7972369138378646_showModal_8020,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_7972369138378646_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7972369138378646_clickPreventStop_8019],
        });
        return {
            act_3343864469950044_reloadComponentData_8010,
            evh_3343864469950044_close_8009,
            act_3343864469950044_showModal_8008,
            evh_3343864469950044_clickPreventStop_8007,
            evh_3343864469950044_clickPreventStop,
            act_8855792642156263_reloadComponentData_8014,
            evh_8855792642156263_close_8013,
            act_8855792642156263_showModal_8012,
            evh_8855792642156263_clickPreventStop_8011,
            evh_8855792642156263_clickPreventStop,
            act_302930856768608_reloadComponentData_8018,
            evh_302930856768608_close_8017,
            act_302930856768608_showModal_8016,
            evh_302930856768608_clickPreventStop_8015,
            evh_302930856768608_clickPreventStop,
            act_7972369138378646_reloadComponentData_8022,
            evh_7972369138378646_close_8021,
            act_7972369138378646_showModal_8020,
            evh_7972369138378646_clickPreventStop_8019,
            evh_7972369138378646_clickPreventStop,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], UcProductPrices.prototype, "product", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('product'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcProductPrices.prototype, "onProduct", null);
UcProductPrices = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcProductPrices);
exports.default = UcProductPrices;
vue_property_decorator_1.Vue.component("UcProductPrices", UcProductPrices);
